import {useState} from 'react'

import useWindowEventListener from './use-window-event-listener'

/**
 * Hook that listens to online / offline events and returns true if online, false otherwise.
 */
export default function useIsOnline() {
  const [isOnline, setOnline] = useState(true)

  useWindowEventListener('online', () => setOnline(true))
  useWindowEventListener('offline', () => setOnline(false))

  return isOnline
}
